package com.mps.asc_app.data.places.model

data class AddressSuggestion(
    val placeId: String,
    val fullText: String
)